export interface ILogoSizes {
  medium: string
  large: string
}
export const logoSizesFormatValidation = (sizes: string): ILogoSizes => {
  const { medium, large } = JSON.parse(sizes) as ILogoSizes
  if (medium && large) return { medium, large }
  throw new Error('Wrong logo size format')
}
